import React from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faSquarePlus, faTrashCan, faPen } from "@fortawesome/free-solid-svg-icons";
import { useBrandsModal, useActionsBrandsModal, useDispatchBrandsModal } from "../../../context/inventory/BrandsModalProvider";
import { types } from "../../../reducers/inventory/brandsReducer";
import Pagination from "../../app/atoms/Pagination";
import "./BrandsCrudModal.css";

export const BrandsCrudModal = ({ show, onHide }) => {
  const state = useBrandsModal();
  const dispatch = useDispatchBrandsModal();
  const action = useActionsBrandsModal();
  const { edit_brand, for_edit } = state;
  const { name, description } = edit_brand;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Gestionar marcas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3 brands-form-row">
          <div className="col-md-4">
            <label className="form-label">Nombre</label>
            <input
              value={name}
              type="text"
              className="form-control"
              maxLength={60}
              onChange={(e) => action.setFieldFormBrand(e.target.value, "name")}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Descripción</label>
            <input
              value={description}
              type="text"
              className="form-control"
              maxLength={150}
              onChange={(e) => action.setFieldFormBrand(e.target.value, "description")}
            />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button
              type="button"
              className="btn-default flex button-form-brand"
              onClick={() => (for_edit ? action.editBrandClick() : action.createBrandClick())}
            >
              <FontAwesomeIcon icon={for_edit ? faFloppyDisk : faSquarePlus} />
              &nbsp;
              <span>{for_edit ? "Guardar" : "Crear"}</span>
            </button>
          </div>
        </div>

        <table className="table table-default-app table-brands-modal">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Nombre</th>
              <th scope="col">Descripción</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {state.elements.map((item) => (
              <tr
                key={item.id}
                className="cursor-pointer td-hoverme"
                onClick={() => action.goToBrandEdit(item.id)}
              >
                <td>{item.id}</td>
                <td>{item.name}</td>
                <td>{item.description ?? "—"}</td>
                <td onClick={(e) => e.stopPropagation()} className="d-flex gap-1">
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0"
                    title="Editar"
                    onClick={() => action.goToBrandEdit(item.id)}
                  >
                    <FontAwesomeIcon icon={faPen} />
                  </button>
                  <button
                    type="button"
                    className="btn btn-link btn-sm text-danger p-0"
                    title="Eliminar"
                    onClick={() => action.deleteBrandClick(item.id)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-end mt-2">
          <Pagination
            onChangepage={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_BRANDS,
                payload: { name: "page", value: e },
              })
            }
            page={state.filter.page}
            limit={state.filter.limit}
            rows={state.rows}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
